<div id="sidebarButton" class="icon d-table-cell" [ngClass]="{'unfolded': sidebarVisible}" >
    <mat-icon svgIcon="menu-arrow-basic-800" class="arrows-icon strict"
              (click)="onDisplayLateralPanel()"></mat-icon>
</div>
